<!-- 预离场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "amountReceivable": 0.01,
                "cmd": "reportInternalParkingPreCarOut",
                "enterTime": "20201016092219",
                "leaveCarLicenseNumber": "粤ACCCC7",
                "leaveChannelCode": "CHANNEL2",
                "leaveChannelCustomCode": "CHANNEL2",
                "leaveChannelId": 2,
                "leaveChargeGroupCode": "",
                "leaveTime": "20201016110915",
                "lockKey": "77694ef01e06e44d13b828f3e6e8e25dac8d6602",
                "parkCode": "2KKN885S",
                "totalAmount": 0.01
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报内部车场预离场信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportInternalParkingPreCarOut",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'leaveCarLicenseNumber', info2: '是', info3: 'String', info4: '出场车牌号' },
                        // { info1: 'leaveChannelCode', info2: '是', info3: 'String', info4: '离场通道自定义编码' },
                        { info1: 'leaveChannelId', info2: '否', info3: 'Long', info4: '离场通道ID' },
                        { info1: 'leaveChannelCustomCode', info2: '否', info3: 'String', info4: '离场通道编码' },
                        { info1: 'leaveChargeGroupCode', info2: '否', info3: 'String', info4: '月卡规则编号' },
                        { info1: 'leaveCarLicenseType', info2: '是', info3: 'Integer', info4: '离场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3白牌，4黑牌白字, 5绿牌）' },
                        { info1: 'leaveCarLicenseColor', info2: '是', info3: 'Integer', info4: '离场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '入场时间，yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '离场时间，yyyyMMddHHmmss' },
                        { info1: 'totalAmount', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'amountReceivable', info2: '是', info3: 'Decimal', info4: '应收金额' },
                        { info1: 'leaveImageArray', info2: '是', info3: 'JSONArray', info4: '智汇云车场，离场图片列表，[{"carImage":"车身图片直接访问url"}]（智汇云支持，上报图片保留90天）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                      { info1: 'fromAreaId', info2: '否', info3: 'String', info4: '来源区域：0为车场外部，其余为区域编码' },
                      { info1: 'toAreaId', info2: '是', info3: 'String', info4: '目的区域：0为车场外部，其余为区域编码' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportInternalParkingPreCarOut.vue